import { render, staticRenderFns } from "./xunta.vue?vue&type=template&id=b6d1daf2&scoped=true&"
import script from "./xunta.vue?vue&type=script&lang=js&"
export * from "./xunta.vue?vue&type=script&lang=js&"
import style0 from "./xunta.vue?vue&type=style&index=0&id=b6d1daf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d1daf2",
  null
  
)

export default component.exports